import React, { useState } from "react";
import styles from "./PropertyOverview.module.css";
import { highlightGoldCoast } from "../../../utils/highlightGoldCoast";

const overviewCopy =
  "Arabella Motor Inn is a comfortable motel in Tweed Heads, about a ten-minute drive from Tweed Heads South, NSW Airport and an easy trip to the Tweed Heads South, NSW beaches. Guests come for a clean room, a straightforward check-in, and a quieter base than a large resort. Queen, deluxe, twin, and family rooms include air conditioning, tea and coffee facilities, a bar fridge, and free Wi-Fi. Many rooms also have a microwave and toaster. Complimentary parking is on site, and the outdoor saltwater pool is there when you want a swim after a day out. Looking for accommodation near Murwillumbah, Tweed Heads accommodation, or a Northern Rivers motel stay? Arabella Motor Inn keeps the focus on a well-kept room and an easy Tweed Heads South, NSW location. The property is non-smoking, with daily room service and a team that can help with local directions for cafes, surf spots and day trips around Tweed Heads and Murwillumbah.";

const PropertyOverview = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <section className={styles.section} aria-label="About Arabella Motor Inn">
      <h2 className={styles.heading}>
        A comfortable stay at Arabella Motor Inn
      </h2>
      <p className={expanded ? styles.body : styles.bodyClamped}>{highlightGoldCoast(overviewCopy)}</p>
      <button
        type="button"
        className={styles.toggle}
        onClick={() => setExpanded((open) => !open)}
        aria-expanded={expanded}
      >
        {expanded ? "See Less" : "See More"}
      </button>
    </section>
  );
};

export default PropertyOverview;
